export const HOME = '/';
export const DESSERT = '/Dessert';
export const CART = '/Cart';
export const CHECKOUT = '/Checkout';
export const FRUITS = '/Fruits';
export const FOOD = '/Food';
export const DRINK = '/Drink';
export const SIGN_IN = '/SignIn';
export const SIGN_UP = '/SignUp';
export const ACCOUNT = '/Account';